var map = {
	"./1.jpg": 1007,
	"./2.jpg": 1008,
	"./3.jpg": 1009,
	"./4.jpg": 1010,
	"./5.jpg": 1011,
	"./AvatarMaestra.jpg": 90,
	"./AvatarMaestro.jpg": 89,
	"./Female.jpg": 350,
	"./Female2.jpg": 269,
	"./Male.jpg": 349,
	"./Male2.jpg": 268
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 552;